var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9141 11.1133L11.9991 14.0413L9.08306 11.1133",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.041L12 2",
    stroke: "#347AF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76898 20.9941C4.3199 20.9941 2.33398 19.0085 2.33398 16.5601V11.6851C2.33398 9.23593 4.31977 7.25014 6.76898 7.25014H7.70198C8.1162 7.25014 8.45198 7.58593 8.45198 8.00014C8.45198 8.41435 8.1162 8.75014 7.70198 8.75014H6.76898C5.1482 8.75014 3.83398 10.0644 3.83398 11.6851L3.83398 16.5601C3.83398 18.1798 5.14807 19.4941 6.76898 19.4941H17.899C19.5199 19.4941 20.834 18.1798 20.834 16.5601V11.6751C20.834 10.0601 19.5245 8.75014 17.91 8.75014H16.967C16.5528 8.75014 16.217 8.41435 16.217 8.00014C16.217 7.58593 16.5528 7.25014 16.967 7.25014H17.91C20.3535 7.25014 22.334 9.23219 22.334 11.6751V16.5601C22.334 19.0085 20.3481 20.9941 17.899 20.9941H6.76898Z",
    fill: "#347AF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSvg);
export default __webpack_public_path__ + "static/media/DownloadSvg.1b4f207eca02017ec2f3dce707caa7d1.svg";
export { ForwardRef as ReactComponent };